import React from 'react';
import YPickLoginQrCode from './YPickLoginQrCode';
import { Popover } from 'antd';
import YPickLoginQrCodeButton from './YPickLoginQrCodeButton';

interface YPickLoginQrCodePopupProps {
  storeId: number;
  fileName: string;
}

/**
 * Popup to display a QR Code for YPick login
 * @param storeId storeId for which to download the QR code
 * @param fileName passed down to the button for saving the QR code
 * @constructor
 */
const YPickLoginQrCodePopup: React.FC<YPickLoginQrCodePopupProps> = ({ storeId, fileName }) => {
  // span is there to display the popover correctly
  return (
    <Popover content={<YPickLoginQrCode storeId={storeId} />} placement="left">
      <span>
        <YPickLoginQrCodeButton storeId={storeId} fileName={fileName} />
      </span>
    </Popover>
  );
};

export default YPickLoginQrCodePopup;
